import { Avatar, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import { Warning } from "@phosphor-icons/react";
import ANMultiProgressBar from "elements/ANMultiProgressBar";
import React from "react";

export default function ClientCaseload({ client }) {
  const theme = useTheme();
  const clientInitials = client.name
    .split(" ")
    .map((name) => name[0])
    .join("");
  return (
    <Stack key={client.id} gap={4} py={4}>
      <Stack direction="row" gap={3} alignItems="center">
        <Avatar size="24px">{clientInitials}</Avatar>
        <Typography variant="body2">{client.name}</Typography>
      </Stack>
      <Stack gap={3}>
        <ANMultiProgressBar
          roundElement
          gap={4}
          backgroundColor="unset"
          elements={client.progressBarElements}
        />
        <Stack direction="row" gap={1} alignItems="center">
          <Warning color={theme.palette.warning.main} weight="duotone" />
          <Typography variant="caption" color="text.secondary">
            Rita starts services August 21st
          </Typography>
        </Stack>
      </Stack>
      <Stack gap={3}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body2">Hours Scheduled</Typography>
          <Typography variant="body2">{client.total}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body2">Proposed Hours</Typography>
          <Typography variant="body2">{client.total}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body2">Target Hours</Typography>
          <Typography variant="body2">{client.total}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body2">Authorized Hours</Typography>
          <Typography variant="body2">{client.total}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
